import { CompanyDockageRepoImpl } from "domain/repository/Company/CompanyDockageRepoImpl";
import { useCompanyDetailTracked } from "presentation/store/Company/CompanyDetailProvider";
import { CompanyDockageVM } from "presentation/viewModel/Company/CompanyDockageVM";
import { useMemo } from "react";

export const useCompanyDockageVM = () => {
    const [, setCompanyDetailState] = useCompanyDetailTracked();
    const companyDockageVM = useMemo(() =>
        CompanyDockageVM({
            dispatch: [setCompanyDetailState],
            companyDockageRepo: CompanyDockageRepoImpl(),
        }), [setCompanyDetailState])

    return companyDockageVM
}